import React, { useMemo } from 'react';
import { Polyline } from 'react-leaflet';
import { colors } from 'global/variables';
import { getMultiJobConnectedStops } from '../../utils/multiJobLineUtils';

const MultiJobConnectionLines = ({ mapData, display }) => {
  const lines = useMemo(() => {
    if (display.selectedTour == null || display.highlightStop == null) {
      return [];
    }
    if (display.highlightStop === -1) {
      return [];
    }
    return getMultiJobConnectedStops(mapData, display.selectedTour, display.highlightStop);
  }, [mapData, display.selectedTour, display.highlightStop]);

  if (!lines.length) return null;

  return (
    <>
      {lines.map(({ from, to }, i) => (
        <Polyline
          key={`multi-job-${display.selectedTour}-${display.highlightStop}-${i}`}
          positions={[
            [from[1], from[0]],
            [to[1], to[0]],
          ]}
          pathOptions={{
            color: colors.multiJobLineColor,
            weight: 4,
            opacity: 0.8,
          }}
        />
      ))}
    </>
  );
};

export default MultiJobConnectionLines;
